/** @format */

import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // will store data in local storage for web
import userReducer from "../reducers/userReducer";
import circleSlice from "../reducers/circleReducer";
import { notificationSlice } from "../reducers/notificationReducer";
import subscriptionReducer from "../reducers/subscriptionReducer";
import reviewReducer from "../reducers/reviewReducer";
import { accountVerificationSlice } from "../reducers/accountVerificationReducer";
import contributionReducer from "../reducers/contributionReducer";
import paymentMethodReducer from "../slices/paymentMethodSlice";
import autoDraftReducer from "../slices/autoDraftSlice";
import adminPayoutReducer from "../reducers/payoutReducer";
import adminRevenueReducer from "../reducers/revenueReducer";
import outstandingDuesReducer from "../actions/outstandingDuesAction";
import circleInvitationReducer from "../reducers/circleInvitationReducer";
import languageReducer from "../slices/languageSlice";
import sandboxReducer from "../slices/sandboxSlice";
import collectReducer from "../slices/collectSlice";
import collectBillingReducer from "../slices/collectBillingSlice";
import collectSupportReducer from "../slices/collectSupportSlice";
import businessAuthReducer from "../slices/businessAuthSlice";

const rootReducer = combineReducers({
	user: userReducer,
	circle: circleSlice,
	notifications: notificationSlice.reducer,
	subscription: subscriptionReducer,
	review: reviewReducer,
	accountVerification: accountVerificationSlice.reducer,
	contribution: contributionReducer,
	paymentMethod: paymentMethodReducer,
	autoDraft: autoDraftReducer,
	adminPayout: adminPayoutReducer,
	adminRevenue: adminRevenueReducer,
	outstandingDues: outstandingDuesReducer,
	circleInvitation: circleInvitationReducer,
	language: languageReducer,
	sandbox: sandboxReducer,
	collect: collectReducer,
	collectBilling: collectBillingReducer,
	collectSupport: collectSupportReducer,
	businessAuth: businessAuthReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

const persistConfig = {
	key: "root",
	storage,
	blacklist: ["someNonSerializableReducer", "collect", "collectBilling", "collectSupport", "businessAuth"],
};

const persistedReducer = persistReducer<RootState>(persistConfig, rootReducer);

export const store = configureStore({
	reducer: persistedReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActions: ["persist/PERSIST"],
			},
		}),
});

// infer root state and add AppDispatch types from the store itself.
// export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const persistor = persistStore(store);
